<template>
  <section class="all-cases-view" v-loading="loading">
    <div class="container-default">
      <div class="listings-navbar">
        <el-row>
          <el-col :lg="17">
            <ul class="d-flex list-items-group-15 conformation-csv">
              <li>
                <span class="csv-header" v-if="resultFileData">
                  {{ resultFileData.name }}
                  <el-tag class="case-type-tag">
                    {{ caseTypeMap[resultFileData.case_type] }}
                  </el-tag>
                </span>
              </li>
            </ul>
          </el-col>
          <el-col :lg="7" v-if="resultFileData">
            <ul class="d-flex justify-content-end list-items-group-15 conformation-csv">
              <li class="csv-header" v-if="
                (resultFileData.case_type == 'UTI' ||
                  resultFileData.case_type == 'WOUND' ||
                  resultFileData.case_type == 'RESPIRATORY_PATHOGEN_PANEL') &&
                hasPermission('cases', 'report_upload_new')
              ">
                <el-button type="primary" @click="setPharamacyReportStatus"
                  v-if="resultFileData.include_pharmacy_report == false">
                  Send Results For Pharmacy Report
                  <el-icon>
                    <Promotion />
                  </el-icon>
                </el-button>
                <el-tag type="success" size="large" round v-else>
                  Results Ready For Pharamcy Report
                  <el-icon>
                    <Finished />
                  </el-icon>
                </el-tag>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="primary-content-view-new" v-if="resultFileData">
        <div class="listings listings__table listings__all-cases" id="all-cases-listings">
          <el-table :data="allSampleNamesData.data" @sort-change="onChangeSort" id="resultFilesTable"
            :row-class-name="currentActiveRowClassName" height="calc(-194px + 100vh)">
            <el-table-column prop="sample_name" label="NAME" width="120" sortable="custom">
              <template #default="scope">
                <div id="order-id">
                  <span>{{ scope.row.sample_name }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="STATUS" width="120" prop="report_status" sortable="custom">
              <template #default="scope">
                <div class="column-status">
                  <span class="el-dropdown-link">
                    <el-tag :type="getStatusType(scope.row.report_status)">
                      {{ scope.row.report_status }}
                    </el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="message" label="MESSAGE" min-width="225" max-width="350">
              <template #default="scope">
                <el-button placement="top" class="title-on-hover" :title="scope.row.message">
                  <span class="text-start" style="word-break: keep-all">
                    {{ scope.row.message }}
                  </span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="response_time" label="DATE" width="100" sortable="custom">
              <template #default="scope">
                <div class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.response_time, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="COVID STATUS" prop="covid_status" sortable="custom" width="150" v-if="
              resultFileData.case_type == 'COVID' ||
              resultFileData.case_type == 'COVID_FLU'
            ">
              <template v-slot="scope">
                <div class="column-status" v-if="scope.row.covid_status">
                  <el-tag :type="getStatusType(scope.row.covid_status)">
                    {{ scope.row.covid_status }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="FINALIZED ON" width="100" prop="finalized_at">
              <template #default="scope">
                <div v-if="scope.row.finalized_at" class="d-flex">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.finalized_at, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="finalized_by" label="FINALIZED BY" width="120">
              <template #default="scope">
                <div v-if="scope.row.finalized_by">
                  <span class="text-center">
                    {{ scope.row.finalized_by.first_name }}
                    {{ scope.row.finalized_by.last_name }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Result Status" width="120" v-if="
              resultFileData.case_type == 'RESPIRATORY_PATHOGEN_PANEL' ||
              resultFileData.case_type == 'TOXICOLOGY' ||
              resultFileData.case_type == 'UTI'
            ">
              <template #default="scope">
                <div class="column-status" v-if="scope.row.result_status">
                  <el-tag :type="getStatusType(scope.row.result_status)">
                    {{ scope.row.result_status }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="
              resultFileData.case_type == 'UTI' ||
              resultFileData.case_type == 'WOUND' ||
              resultFileData.case_type == 'RESPIRATORY_PATHOGEN_PANEL'
            " prop="pharmacy_report_sync_status" label="Send Pharamacy Order" width="180">
              <template #default="scope" v-if="resultFileData.include_pharmacy_report == true">
                <div v-if="scope.row.pharmacy_report_order_status == 'TO-START'">
                  <el-button type="text" class="view-progress-btn" @click="sendPharmacyOrder(scope.row)">Send
                    Order</el-button>
                </div>
                <div v-else-if="scope.row.pharmacy_report_order_status == 'FAILED'">
                  <el-tooltip :content="scope.row.pharmacy_report_order_status" placement="top" effect="dark">
                    <el-button type="text" class="view-progress-btn"
                      @click="sendPharmacyOrder(scope.row)">Re-send</el-button>
                  </el-tooltip>
                </div>
                <div v-else class="column-status">
                  <el-tag :type="getStatusType(scope.row.pharmacy_report_order_status)
                    ">{{ scope.row.pharmacy_report_order_status }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="
              resultFileData.case_type == 'UTI' ||
              resultFileData.case_type == 'WOUND' ||
              resultFileData.case_type == 'RESPIRATORY_PATHOGEN_PANEL'
            " prop="pharmacy_report_sync_status" label="Sync Report" width="150">
              <template #default="scope" v-if="resultFileData.include_pharmacy_report == true">
                <div v-if="scope.row.pharmacy_report_order_status == 'COMPLETED'">
                  <div v-if="scope.row.pharmacy_report_sync_status == 'TO-START'">
                    <el-button type="text" class="view-progress-btn" @click="syncPharamcyReport(scope.row)">Sync
                      report</el-button>
                  </div>
                  <div v-else-if="
                    scope.row.pharmacy_report_sync_status == 'FAILED'
                  ">
                    <el-button type="text" class="view-progress-btn" @click="syncPharamcyReport(scope.row)">Resync
                      report</el-button>
                  </div>
                  <div v-else class="column-status">
                    <el-tag :type="getStatusType(scope.row.pharmacy_report_sync_status)
                      ">{{ scope.row.pharmacy_report_sync_status }}</el-tag>
                  </div>
                </div>
                <div v-else class="column-status">
                  <el-tag :type="getStatusType(scope.row.pharmacy_report_sync_status)">{{
                    scope.row.pharmacy_report_sync_status }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="action" fixed="right" label="Actions" width="220">
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li v-if="
                    scope.row.report_status != 'FAILED' &&
                    scope.row.report_status != 'TO-START'
                  ">
                    <el-button class="view-button" @click="onUTIDownloadReport(scope.row)" v-if="
                      (resultFileData.case_type == 'UTI' ||
                        resultFileData.case_type == 'WOUND' ||
                        resultFileData.case_type ==
                        'RESPIRATORY_PATHOGEN_PANEL') &&
                      scope.row.pharmacy_report_merged_report_path &&
                      scope.row.download_ready
                    ">
                      <img class="action-active" src="@/assets/images/icons/actions/download-new-active.svg"
                        alt="icon" />
                      <img class="action-inactive" src="@/assets/images/icons/actions/download-new.svg" alt="icon" />
                    </el-button>
                    <el-button class="view-button" @click="onDownloadReport(scope.row)" v-else>
                      <img class="action-active" src="@/assets/images/icons/actions/download-new-active.svg"
                        alt="icon" />
                      <img class="action-inactive" src="@/assets/images/icons/actions/download-new.svg" alt="icon" />
                    </el-button>
                  </li>

                  <li v-if="
                    scope.row.report_status != 'FAILED' &&
                    scope.row.report_status != 'TO-START'
                  ">
                    <el-button class="view-button" @click="viewReport(scope.row)">
                      <img class="action-active" src="@/assets/images/icons/actions/view-icon.svg" alt="icon" />
                      <img class="action-inactive" src="@/assets/images/icons/actions/view-inactive.svg" alt="icon" />
                    </el-button>
                  </li>
                  <li v-if="
                    scope.row.case_type == 'UTI' &&
                    scope.row.report_status == 'COMPLETED'
                  ">
                    <el-button class="discrete-results-btn" @click="downloadDiscreteResults(scope.row)"
                      title="EXPORT DISCRETE RESULTS">
                      DR
                    </el-button>
                  </li>
                  <li v-if="
                    resultFileData.case_type.toLowerCase() == 'toxicology' &&
                    scope.row.report_status != 'FAILED' &&
                    scope.row.report_status != 'TO-START' &&
                    hasPermission('cases', 'report_upload_new')
                  ">
                    <el-button @click="onReportEdit(scope.row)" :disabled="scope.row.is_finalized" :title="scope.row.is_finalized
                        ? 'This case is already finalized'
                        : 'Edit Report'
                      ">
                      <img class="action-active" src="@/assets/images/icons/actions/edit-active.svg" alt="icon" />
                      <img class="action-inactive" src="@/assets/images/icons/actions/edit-deactive.svg" alt="icon" />
                    </el-button>
                  </li>
                  <li v-if="scope.row.report_status == 'FAILED'">
                    <el-button class="view-button" @click="regenerateFailedReport(scope.row)">
                      <img src="@/assets/images/icons/actions/restore-icon.svg" alt="icon" class="img-fluid" />
                    </el-button>
                  </li>
                  <li v-if="
                    scope.row.report_status == 'COMPLETED' &&
                    !scope.row.is_finalized &&
                    hasPermission('cases', 'report_upload_new')
                  ">
                    <el-button class="finalize-btn" @click="finalizeReport(scope.row)" :disabled="!hasPermission('test_report', 'finalize_report')
                      ">Finalize</el-button>
                  </li>

                  <li class="d-flex align-center" v-if="scope.row.is_finalized == true">
                    <el-button class="finalized-btn">Finalized</el-button>
                  </li>
                  <li v-if="
                    scope.row.case_type != 'UTI' &&
                    scope.row.case_type != 'WOUND' &&
                    scope.row.case_type != 'RESPIRATORY_PATHOGEN_PANEL'
                  ">
                    <el-button class="delete-button" @click="downloadCsvReport(scope.row)">
                      <img src="@/assets/images/icons/actions/csv-file-icon.svg" alt="icon" class="img-fluid" />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination v-model:currentPage="page" v-model:page-size="pageSize" :page-sizes="[10, 25, 50, 100]"
            layout=" prev, pager, next, jumper, sizes ,total" :total="allSampleNamesData.total"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import caseConstants from "@/config/constants/caseConstants";
import FileDownloadHelper from "@/mixins/FileDownloadHelper";
import FilterHelper from "@/mixins/FilterHelper";
import GlobalHelper from "@/mixins/GlobalHelper";
import io from "socket.io-client";

import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [
    UserPermissionsHelper,
    FileDownloadHelper,
    FilterHelper,
    GlobalHelper,
  ],
  computed: {
    ...mapGetters("respiratoryFileUpload", [
      "getUploadedDocumentDetails",
      "getGenerateReportStatus",
      "getGeneratedReportsFromFileUploads",
      "getGenerateFailedReportStatus",
      "getSelectedResultFileData",
      "getCovidStatusUpdated",
      "getCovidStatusUpdateError",
      "getFileDownloadUrl",
      "getSampleNameTestResultData",
      "getEditReportAccess",
      "getReportEditBlockingReason",
    ]),
    ...mapGetters("emrOrders", [
      "getSendReportStatus",
      "getEmrUniBiDirectionalStatus",
      "getSendAthenaEMRDiscreteResultsStatus",
    ]),
    ...mapGetters("cases", [
      "getReportGenerateStatus",
      "getTestReportURL",
      "getFaxSentStatus",
      "getReportSentToPatientStatus",
      "getReportSentToPatientBySMSStatus",
      "getDownloadReportData",
    ]),
    ...mapGetters("auth", ["getAuthenticationDetails"]),
    ...mapGetters("errors", ["getError"]),
    ...mapGetters("resultFiles", [
      "getPharamcyReportSentStatus",
      "getPharmacyOrderSentStatus",
      "getPharmacySyncStatus",
      "getdownloadDiscreteResultsStatus",
    ]),
    getStatusType() {
      return (status) => {
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        }
        if (status == "FAILED") {
          return "danger";
        } else if (status == "COMPLETED") {
          return "success";
        }
        if (status == "INCONSISTENT") {
          return "warning";
        } else if (status == "CONSISTENT") {
          return "success";
        }
        if (status == "PROCESSING") {
          return "warning";
        } else {
          return "";
        }
      };
    },
    getRppStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else {
          return "";
        }
      };
    },
    paginationProps() {
      return {
        pageSizes: this.pageSizes || [10, 15, 25, 50],
      };
    },
    resultFileId() {
      return this.$route.params.result_file_id;
    },
  },
  async mounted() {
    this.setQueryParams();
    await this.fetchFileReportStatusData();
  },
  data() {
    return {
      page: 1,
      loading: false,
      files: {},
      dialogVisible: false,
      selectedCaseId: null,
      exportDialogVisisble: false,
      fieldList: [],
      date_type: "collection_date",
      pageSize: 10,
      generatedReportsTableDialog: false,
      btnLoading: false,
      result_file_id: "",
      resultFileData: null,
      refreshPageSeconds: 2000,
      statuses: ["TO-START", "PROCESSING", "FAILED", "COMPLETED"],
      selectedStatus: "",
      allSampleNames: [],
      allSampleNamesData: {
        data: [],
        page: 1,
        total: 0,
      },
      refresh: false,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      loadingText: "Fetching Data....",
      orderBy: "",
      orderType: "",

      orderTypeMap: {
        ascending: "ASC",
        descending: "DESC",
      },
      reportData: null,
      finalizedAccession: "",

      // emr options
      askEmrConfig: false,
      resultStatusOptions: [
        {
          label: "Completed",
          value: "COMPLETED",
        },
        {
          label: "Corrected",
          value: "CORRECTED",
        },
      ],
      emrNotes: "",
      emrResultStatus: "COMPLETED",
      selectedFinalizedReport: null,

      // Fax options
      askFaxConfig: false,
      sendReportToEMR: true,
      sendReportToFax: true,
      finalizedCaseData: null,
    };
  },
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  methods: {
    async downloadDiscreteResults(report) {
      try {
        this.loading = true;
        let params = {
          result_file_id: this.resultFileId,
          report_id: report._id,
          test_results_id: report.test_results_id,
        };
        await this.$store.dispatch("resultFiles/downloadDiscreteData", params);
        if (this.getdownloadDiscreteResultsStatus) {
          const url = window.URL.createObjectURL(
            new Blob([this.getdownloadDiscreteResultsStatus])
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${report.sample_name}.csv`); //or any other extension
          document.body.appendChild(link);
          link.click();
          successNotification("Discrete Results downloaded successfully");
        } else {
          errorNotification("Error while downloading Discrete Results");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async onReportEdit(data) {
      this.loading = true;
      this.loadingText = "Checking edit status";
      let enabled = await this.checkEditEanbled(data);
      this.loading = false;

      if (!enabled) {
        this.$alert(
          this.getReportEditBlockingReason ||
          "Case reports already finalized you cannot edit any report",
          "Warning",
          {
            confirmButtonText: "OK",
          }
        );
        return;
      }

      let routerData = this.$router.resolve({
        name: "toxicology-test-results",
        params: {
          result_file_id: this.resultFileId,
          report_id: data._id,
          test_results_id: data.test_results_id,
        },
      });
      window.location.href = routerData.href;
    },

    async checkEditEanbled(data) {
      try {
        if (data.is_finalized) return false;
        let params = {
          sample_name_id: data._id,
        };
        await this.$store.dispatch(
          "respiratoryFileUpload/checkReportEditStatus",
          params
        );
        if (this.getEditReportAccess) {
          return true;
        } else {
          return false;
        }
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: "Error on generating test report",
        });
      }
    },
    async regenerateFailedReport(report) {
      let params = {
        result_file_id: this.resultFileId,
        sample_name_id: report._id,
      };
      this.btnLoading = true;
      this.loading = true;
      await this.$store.dispatch(
        "respiratoryFileUpload/regenerateFailedReportsFromFileUploads",
        params
      );
      this.loading = false;
      this.btnLoading = false;
      if (
        this.getGenerateFailedReportStatus &&
        this.getGenerateFailedReportStatus.success
      ) {
        successNotification(this.getGenerateFailedReportStatus.message);

        this.finalizedAccession = report.sample_name;
        this.updateQueryParamsData();
        window.location.reload();
      } else {
        errorNotification("Error while creating report generation");
      }
    },
    async setPharamacyReportStatus() {
      try {
        this.loading = true;
        let params = {
          id: this.$route.params.result_file_id,
        };
        await this.$store.dispatch(
          "resultFiles/setPharamcyReportStatus",
          params
        );
        if (this.getPharamcyReportSentStatus) {
          successNotification(
            "Result file pharmacy report status updated  successfully"
          );
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else {
          errorNotification(this.getError || "Error while updating status");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async syncPharamcyReport(data) {
      try {
        this.loading = true;
        let params = {
          id: this.$route.params.result_file_id,
          report_id: data._id,
        };
        await this.$store.dispatch("resultFiles/syncPharamacyReports", params);
        if (this.getPharmacySyncStatus) {
          successNotification("Reports sync successfully");
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          errorNotification(this.getError || "Error while sync reports");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async sendPharmacyOrder(data) {
      try {
        this.loading = true;
        let params = {
          id: this.$route.params.result_file_id,
          report_id: data._id,
        };
        await this.$store.dispatch("resultFiles/sendPharamacyOrder", params);
        if (this.getPharmacyOrderSentStatus) {
          successNotification(
            "Pharmacy order sending process started successfully"
          );
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        } else {
          errorNotification(this.getError || "Error while sending order");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    hasCovid(caseData) {
      return caseData.panels && caseData.panels.indexOf("COVID") > -1;
    },

    getStyle(status) {
      if (status === "FAILED") {
        return "danger";
      } else if (status === "COMPLETED") {
        return "success";
      } else {
        return "";
      }
    },

    getNegetive() { },

    async fetchFileReportStatusData() {
      this.loading = true;
      let params = {
        id: this.resultFileId,
        limit: this.pageSize,
        page: this.page,
      };

      if (this.orderBy && this.order_type) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType === "ascending" ? "asc" : "desc";
      }

      if (this.selectedStatuses) {
        params.report_status = this.selectedStatuses;
      }

      await this.$store.dispatch(
        "respiratoryFileUpload/fetchGeneratedReportsFromFileUploads",
        params
      );

      this.resultFileData = this.getSelectedResultFileData;
      this.allSampleNamesData = this.getGeneratedReportsFromFileUploads;
      await this.updateQueryParamsData();

      const tableElement = document.getElementById("resultFilesTable");

      if (tableElement) {
        const activeRow = tableElement.getElementsByClassName(
          "active-finalize-row"
        )[0];
        if (activeRow) {
          activeRow.scrollIntoView({ block: "center" });
        }
      }

      this.loading = false;
    },
    async updateQueryParamsData() {
      let params = {
        selectedResultDetailsPage: this.page,
        selectedResultDetailsPageSize: this.pageSize,
        selectedResultDetailsReportStatus: this.selectedStatus,
        finalizedAccession: this.finalizedAccession,
      };
      params = { ...this.$route.query, ...params };
      await this.updateQueryParam(this.$route.name, params);
    },
    setQueryParams() {
      this.page = parseInt(this.$route.query.selectedResultDetailsPage) || 1;
      this.pageSize =
        parseInt(this.$route.query.selectedResultDetailsPageSize) || 10;
      this.selectedStatus = this.$route.query.selectedResultDetailsReportStatus;
      this.finalizedAccession = this.$route.query.finalizedAccession;
    },
    async loadData(data) {
      if (data && data.type !== "init") {
        let page = this.page;
        if (
          data.sort &&
          data.sort.prop &&
          data.sort.order &&
          (this.orderBy !== data.sort.prop ||
            this.orderType !== data.sort.order)
        ) {
          page = this.page;
        } else if (
          !this.checkTotal(
            this.allSampleNamesData.total,
            data.page,
            data.pageSize
          ) ||
          (data.type == "sort" && data.sort && !data.sort.order)
        ) {
          page = 1;
        } else {
          page = data.page;
        }

        this.pageSize = data.pageSize;
        this.page = page;
        if (data.sort && data.sort.prop && data.sort.order) {
          this.orderBy = data.sort.prop;

          this.orderType = data.sort.order;
        }

        await this.fetchFileReportStatusData();
      }
    },
    refreshPage() {
      setTimeout(() => {
        this.fetchFileReportStatusData();
      }, this.refreshPageSeconds);
    },
    closeGeneratedReportsDialog() {
      this.generatedReportsTableDialog = false;
    },
    async viewReport(report) {
      this.loading = true;
      await this.generateReport(report, true, false);
      try {
        let routerData = this.$router.resolve({
          name: "ResultFileReport",
          params: {
            result_file_id: this.resultFileId,
            report_id: report._id,
            test_results_id: report.test_results_id,
          },
        });
        window.open(routerData.href, "_blank");
      } catch (err) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async onUTIDownloadReport(report) {
      this.loading = true;
      this.loadingText = "Downloading Report....";
      let source = report.pharmacy_report_merged_report_path;
      await this.$store.dispatch("cases/fetchTestReportDownloadURL", {
        path: source,
      });

      let url = this.getDownloadReportData.data.download_url;
      window.open(url, "_blank");
      this.loading = false;
    },
    async onDownloadReport(report) {
      this.loading = true;
      this.loadingText = "Downloading Report....";

      if (report.download_ready) {
        await this.generateReport(report);
      } else {
        await this.generateReport(report);
      }
      this.loading = false;
    },
    async downloadReportFile(report, download = true) {
      const reportPath = report.report_path;
      await this.$store.dispatch("respiratoryFileUpload/fetchFileDownloadUrl", {
        path: report.report_path,
      });
      if (download) {
        let url = this.getFileDownloadUrl.download_url;
        await this.renameAndDownloadFile(url, reportPath.split("/")[1]);
      }
    },
    async generateReportWhileFinalizing(report) {
      try {
        await this.$store.dispatch("cases/generateTestReport", {
          case_id: report.sample_name,
          accession_id: report.sample_name,
          case_type: report.case_type,
          report_id: report._id,
          test_results_id: report.test_results_id,
          result_file_id: this.resultFileId,
          skip_download: true,
        });
      } catch (err) {
        console.log(err);
      }
    },
    async generateReport(report, skipDownload = false, showSuccess = true) {
      try {
        await this.$store.dispatch("cases/generateTestReport", {
          case_id: report.sample_name,
          accession_id: report.sample_name,
          case_type: report.case_type,
          report_id: report._id,
          test_results_id: report.test_results_id,
          result_file_id: this.resultFileId,
          skip_download: skipDownload,
        });

        if (this.getReportGenerateStatus && showSuccess) {
          successNotification("Test Report Downloaded Successfully");
          await this.fetchFileReportStatusData();
        } else if (!this.getReportGenerateStatus) {
          errorNotification(
            this.getError || "Error while downloading test report"
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    getRouterData(report) {
      let routerData;
      if (report.case_type == "COVID") {
        routerData = this.$router.resolve({
          name: "ResultFileReport",
          params: {
            result_file_id: this.resultFileId,
            report_id: report._id,
            test_results_id: report.test_results_id,
          },
        });
      } else if (report.case_type == "RESPIRATORY_PATHOGEN_PANEL") {
        routerData = this.$router.resolve({
          name: "ResultFileRppReport",
          params: {
            result_file_id: this.resultFileId,
            report_id: report._id,
            test_results_id: report.test_results_id,
          },
        });
      } else {
        routerData = this.$router.resolve({
          name: "ResultFileUTIReport",
          params: {
            result_file_id: this.resultFileId,
            report_id: report._id,
            test_results_id: report.test_results_id,
          },
        });
      }
      return routerData;
    },
    getStatuSampleNames(status) {
      this.selectedStatus = status;
      this.fetchFileReportStatusData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchFileReportStatusData();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchFileReportStatusData();
    },

    async downloadCsvReport(report) {
      let params = {
        result_file_id: this.resultFileId,
        sample_name_id: report._id,
        test_result_id: report.test_results_id,
        sample_name: report.sample_name,
      };

      await this.$store.dispatch(
        "respiratoryFileUpload/downloadReportCsvData",
        params
      );
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
    },
    async changeCovidStatus(
      command,
      id,
      test_results_id,
      sample_name,
      index,
      prevStatus,
      isFinalized
    ) {
      if (command == prevStatus || isFinalized) {
        return;
      }

      this.allSampleNamesData.data[index].covid_status = command;
      setTimeout(() => {
        this.refresh = false;
      }, 500);
    },

    async finalizeReport(data) {
      this.loading = true;
      this.selectedFinalizedReport = null;
      let params = this.prepareParams(data);
      this.finalizedAccession = data.sample_name;
      await this.$store.dispatch(
        "respiratoryFileUpload/updateCovidStatus",
        params
      );
      if (this.getCovidStatusUpdated && this.getCovidStatusUpdated.success) {
        successNotification("Test Report Finalized!");
        await this.updateQueryParamsData();
        await this.generateReportWhileFinalizing(data);
        await this.generateReport(data, true, false);
        await this.fetchFileReportStatusData();
        this.loading = false;
        if (this.getReportGenerateStatus) {
          if (
            this.getCovidStatusUpdated.data &&
            this.getCovidStatusUpdated.data.patient_email_status &&
            this.getCovidStatusUpdated.data.patient_email_data &&
            this.getCovidStatusUpdated.data.release
          ) {
            await this.sendReportToPatient(
              this.getCovidStatusUpdated.data.patient_email_data
            );
          }
          if (
            this.getCovidStatusUpdated.data &&
            this.getCovidStatusUpdated.data.patient_sms_status &&
            this.getCovidStatusUpdated.data.patient_sms_data &&
            this.getCovidStatusUpdated.data.release
          ) {
            await this.sendReportToPatientBySMS(
              this.getCovidStatusUpdated.data.patient_sms_data
            );
          }
          this.selectedFinalizedReport = {
            ...data,
            ...this.getCovidStatusUpdated.data,
          };
          if (
            this.getCovidStatusUpdated.data &&
            this.getCovidStatusUpdated.data.auto_fax &&
            this.getCovidStatusUpdated.data.release
          ) {
            await this.sendFax();
          }
          if (
            this.getCovidStatusUpdated.data &&
            this.getCovidStatusUpdated.data.emr_status
          ) {
            await this.sendToEmr();
          } else {
            setTimeout(() => {
              window.location.reload();
            }, 500);
          }
        } else {
          errorNotification(this.getError || "Error in Generating Report");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
      } else {
        this.loading = false;

        errorNotification(
        this.getError || this.getCovidStatusUpdateError || "Status Not Updated"
        );
        window.location.reload();
      }
    },
    prepareParams(data) {
      let params = {
        result_file_id: this.resultFileId,
        sample_name_id: data._id,
        test_result_id: data.test_results_id,
        sample_name: data.sample_name,
      };

      if (data.covid_status) {
        params.covid_status = data.covid_status;
      }
      params.report_status = this.selectedStatuses;

      return params;
    },
    // sending report
    async sendReport() {
      if (this.sendReportToFax) {
        await this.sendFax();
      }
      if (this.sendReportToEMR) {
        await this.sendToEmr();
      }
    },
    // emr config methods
    async sendToEmr(loading = true) {
      try {
        if (loading) {
          this.loading = true;
        }
        let params = this.buildEmrParams();
        await this.$store.dispatch("emrOrders/sendReportToEmr", params);
        if (
          this.getSendReportStatus ||
          this.getEmrUniBiDirectionalStatus ||
          this.getSendAthenaEMRDiscreteResultsStatus
        ) {
          this.askEmrConfig = false;
          successNotification("EMR send successfully");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          errorNotification(this.getError || "Error in send report to EMR");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    buildEmrParams() {
      let params = {
        notes: [this.emrNotes],
        result_status: this.emrResultStatus,
        emr_result_status: this.emrResultStatus,
        test_report_ids: this.selectedFinalizedReport.test_report_ids,
        finalized_report_ids: this.selectedFinalizedReport.test_report_ids,
        order_id: this.selectedFinalizedReport.emr_order_id,
        emr_order_id: this.selectedFinalizedReport.emr_order_id,
      };
      if (this.selectedFinalizedReport.covid_status) {
        params.covid_status = this.selectedFinalizedReport.covid_status;
      }
      return params;
    },
    // Fax Options
    async sendFax() {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/sendFax", {
          case_id: this.selectedFinalizedReport.case_id,
          report_id: this.selectedFinalizedReport.test_report_ids[0],
        });
        if (this.getFaxSentStatus) {
          successNotification("Fax Sent Successfully", "Success", 1500);
        } else {
          errorNotification(this.getError || "Error in sending Fax");
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    currentActiveRowClassName({ row }) {
      if (
        this.$route.query &&
        this.$route.query.finalizedAccession &&
        row.sample_name == this.$route.query.finalizedAccession
      ) {
        return "active-finalize-row";
      }
    },
    // sending report to patient By Email
    async sendReportToPatient(data) {
      try {
        this.loading = true;
        let params = {
          path: this.getTestReportURL,
          case_type: data.case_type,
          patient_info: data.patient_demographics,
          accession_id: data.accession_id || null,
        };
        await this.$store.dispatch("cases/resendReportToPatient", params);
        this.loading = false;
        if (this.getReportSentToPatientStatus) {
          successNotification("Mail send to patient successfully");
        } else {
          if (!this.getReportSentToPatientStatus) {
            errorNotification(
              this.getError || "Error in sending Mail to Patient"
            );
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    // sending report to patient By SMS
    async sendReportToPatientBySMS(data) {
      try {
        this.loading = true;
        let params = {
          path: this.getTestReportURL,
          case_type: data.case_type,
          patient_info: data.patient_demographics,
          accession_id: data.accession_id || null,
        };
        await this.$store.dispatch("cases/resendReportToPatientBySMS", params);
        this.loading = false;
        if (this.getReportSentToPatientBySMSStatus) {
          successNotification("SMS send to patient successfully");
        } else {
          if (!this.getReportSentToPatientBySMSStatus) {
            errorNotification(
              this.getError || "Error in sending SMS to Patient"
            );
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
